module.exports = __webpack_public_path__ + "static/media/webpay-plus.153f56e2.png";